import type { ReactNode } from 'react'

/**
 * Пустой ли слот. Проверяет и `boolean`, потому что идиома правила 8
 * `can('order.edit') && <Button />` при отсутствии права отдаёт `false`, а не `undefined`:
 * без этой проверки обёртка слота рендерится пустой — с отступом, гэпом и без содержимого.
 * Пустая строка сюда же: `t('…', { count: 0 })` вправе вернуть '' , и рисовать под неё узел незачем.
 */
export function isFilled(slot: ReactNode): boolean {
  return slot !== undefined && slot !== null && slot !== '' && typeof slot !== 'boolean'
}

/**
 * Пустое значение данных: не пришло с бэка или пришло пустой строкой.
 *
 * Отличается от `isFilled`: тот про **слот разметки** (можно ли рисовать обёртку),
 * этот про **величину** (рисовать значение или прочерк). Вынесено на четвёртом повторении —
 * MetricTile, SummaryList, StatusBadge, SpecTable писали одно и то же выражение.
 */
export function isBlank(value: unknown): boolean {
  return value === undefined || value === null || value === ''
}
